import ReactCollapsible from 'react-collapsible';
import { Icon } from 'palette/Icon';
import { Typography } from 'palette/Typography';
import { useConfig } from '@common/Hooks/useConfig';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';
import { LeftNavigationItemGroup } from './LeftNavigationItemGroup';
import '../styles/LeftNavigationAccordion.scss';

export function LeftNavigationAccordion({
    persistedFiltersGroup,
    item,
    isOpen,
    onActiveAccordionChange
}) {
    const config = useConfig();
    const {
        isProductCountHidden, name, children
    } = item;
    const accordionHeader = (
        <>
            <Typography
                tagName="span"
                type="body"
                weight={isOpen ? 'bold' : 'regular'}
            >
                {getTranslatedPropertyFromContext(item, 'name', config)}
            </Typography>
            <Icon
                className="left-navigation-accordion__icon"
                name="palette_chevron_down"
                size="x-small"
            />
        </>
    );

    return (
        <ReactCollapsible
            classParentString="left-navigation-accordion"
            contentElementId={`left_navigation_collapsible_content_${name}`}
            easing="ease-in-out"
            handleTriggerClick={() => onActiveAccordionChange(isOpen ? null : name)}
            open={isOpen}
            openedClassName="left-navigation-accordion--active"
            transitionTime={200}
            trigger={accordionHeader}
            triggerElementProps={{ id: `left_navigation_collapsible_trigger_${name}` }}
        >
            <LeftNavigationItemGroup
                customClass="left-navigation-accordion__body"
                data-title={getTranslatedPropertyFromContext(item, 'name', config)}
                isCountHidden={isProductCountHidden}
                items={children}
                persistedFiltersGroup={persistedFiltersGroup}
            />
        </ReactCollapsible>
    );
}
